import { SectionLabel, Reveal, CtaButton } from "./shared";

const TRUST = [
  "Free to attend — no cost, no obligation",
  "No credit pull required to attend",
  "Live Q&A with Josh",
  "A limited number of Better Deal Reviews™ are available after each live class because Josh personally reviews the completed information",
];

export default function FinalRegister() {
  return (
    <section id="register" className="relative py-24 lg:py-36 px-6 lg:px-10 bg-[#00224F]/50 bg-grid-80 overflow-hidden" data-testid="final-register-section">
      <div
        className="absolute left-0 top-1/2 -translate-y-1/2 w-[700px] h-[700px] pointer-events-none"
        style={{ background: "radial-gradient(circle, rgba(1,98,202,0.18) 0%, transparent 65%)" }}
      />
      <div className="relative max-w-6xl mx-auto">
        <Reveal>
          <SectionLabel n="009" text="SAVE YOUR SEAT" />
          <h2
            className="font-black uppercase tracking-tight leading-[0.98] max-w-3xl"
            style={{ fontSize: "clamp(34px, 4.5vw, 60px)" }}
          >
            YOUR NEXT MOVE STARTS WITH A CLEARER <span className="text-[#0162CA]">MAP.</span>
          </h2>
          <ul className="mt-10 space-y-4 max-w-2xl">
            {TRUST.map((t, i) => (
              <li key={i} className="flex gap-3 text-white/70 text-[15px] leading-relaxed" data-testid={`trust-bullet-${i + 1}`}>
                <span className="text-[#0162CA] font-bold shrink-0">✓</span>
                {t}
              </li>
            ))}
          </ul>
          <div className="mt-10">
            <CtaButton testId="final-register-cta" />
          </div>
        </Reveal>
      </div>
    </section>
  );
}
